import MuiGrid, { GridProps } from '@mui/material/Grid';
import ModulEnum from "src/enums/ModulEnum";
import { isVisible } from "src/utils/formAuthHelper";

export interface IGridProps extends GridProps {
  authCode?: string;
  modul?: ModulEnum;
}

const Grid = (props: IGridProps): JSX.Element => {
  return (
    isVisible(props.authCode, props.modul) && (<MuiGrid
      {...props}
      xs={props.item ? (props.xs ? props.xs : 12) : props.xs}
      spacing = {props.container ? 1.4 : props.spacing}
      columnSpacing = {props.container ? 1.4 : props.columnSpacing}
      rowSpacing = {props.container ? 1.4 : props.rowSpacing}
      sx= {{...props.sx, paddingBottom:`${props.container ? "1px" : "0px" }`}}
    />)
  );
};

export default Grid;
